import DpaListItem from '@/Components/Cards/DpaListItem.vue';
import ListItem from '@/Components/Cards/ListItem.vue';
import DpaHero from '@/Components/Cards/DpaHero.vue';
import Hero from '@/Components/Cards/Hero.vue';

export function useArticleComponentMap(type) {
    switch (type) {
        case 'dpa_articles': {
            return DpaListItem;
        }

        default: {
            return ListItem;
        }
    }
}

export function useHeroComponentMap(type) {
    switch (type) {
        case 'dpa_articles': {
            return DpaHero;
        }

        default: {
            return Hero;
        }
    }
}
